import saveAs from 'file-saver';

export function downloadPdfFromBlob(blob: Buffer, storyTitle = 'story'): Blob {
  const newBlob: Blob = new Blob([blob], { type: 'application/pdf' });
  saveAs(newBlob, `${storyTitle}.pdf`);
  return newBlob;
}
